import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";

import img_icon_info_icon from "@/Globals/_images/icons/info_icon.png";
import img_icon_info_icon_red from "@/Globals/_images/icons/info_icon_red.png";

interface InfoIconControlProps {
    isException?: boolean;
    onClick?: () => void;
    containerStyles?: React.CSSProperties;
    containerClassName?: string;
    imgProps?: {
        id?: string;
        alt?: string;
        "aria-expanded"?: "true" | "false",
        "aria-controls"?: string;
        "data-dropdown"?: string;
        style?: React.CSSProperties;
    }
}

class InfoIconControl extends BaseReactComponent<InfoIconControlProps> {
    public render(): JSX.Element {
        let indicatorIconUrl = this.props.isException
            ? img_icon_info_icon_red
            : img_icon_info_icon;

        return (
            <div
                className={`pointer ${this.props.containerClassName ?? ""}`}
                style={this.props.containerStyles}
                onClick={e => {
                    e.stopPropagation();
                    this.props.onClick?.();
                }}
            >
                <img
                    className="file-img"
                    src={indicatorIconUrl}
                    {...this.props.imgProps}
                />
            </div>
        );
    }
}

export { InfoIconControl };
